(function () {
  'use strict';

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function getRoot() {
    return document.getElementById('vstar-reviews') || document.querySelector('.trustoo-reviews-wrapper');
  }

  /* V7.11.28 — dedicated all-reviews page helpers. Trustoo's review-switch app
     block is native and remains the source of truth for Product vs Store reviews.
     LAF only prevents our cleanup pass from hiding it and styles the existing
     controls. */
  function isGlobalReviewsPage() {
    return /\/pages\/les-avis-de-nos-clients\/?$/i.test(window.location.pathname || '');
  }

  function reviewSwitchProductMatch(text) {
    var t = normalizeText(text);
    if (!t) return false;
    if (/(?:avis\s*(?:sur\s+les\s+)?produits?|product\s*reviews?)/i.test(t)) return true;
    /* Trustoo often labels the product tab simply “Avis (219)” / “Reviews (219)”. */
    return /^(?:avis|reviews?|commentaires?)(?:\s*\(\s*\d+\s*\))?$/i.test(t);
  }

  function reviewSwitchStoreMatch(text) {
    return /(?:avis\s*(?:de\s+la\s+|sur\s+la\s+)?(?:boutique|magasin|site)|(?:store|shop)\s*reviews?|reviews?\s*(?:de\s+la\s+)?boutique)/i.test(normalizeText(text));
  }

  function reviewSwitchControlText(el) {
    if (!el) return '';
    var parts = [el.textContent, el.value, el.getAttribute && el.getAttribute('aria-label'), el.getAttribute && el.getAttribute('title'), el.getAttribute && el.getAttribute('data-label'), el.getAttribute && el.getAttribute('data-title'), el.getAttribute && el.getAttribute('data-type')];
    return normalizeText(parts.filter(Boolean).join(' '));
  }

  function closestReviewSwitchCommon(a, b) {
    if (!a || !b) return null;
    var node = a;
    for (var i = 0; i < 10 && node && node !== document.body; i++, node = node.parentElement) {
      if (!node.contains(b)) continue;
      var text = normalizeText(node.textContent);
      var controls = node.querySelectorAll ? node.querySelectorAll('button,a,[role="tab"],label,input[type="radio"]').length : 0;
      if (text.length <= 420 && controls <= 8) return node;
    }
    return null;
  }

  function clearLafHiddenFlags(node, stopAt) {
    var current = node;
    while (current && current !== document.body) {
      current.removeAttribute('data-laf-native-summary-shell');
      current.removeAttribute('data-laf-orphan-summary');
      current.removeAttribute('data-laf-empty-shell');
      if (current === stopAt) break;
      current = current.parentElement;
    }
  }

  function markNativeReviewSwitch(root) {
    if (!isGlobalReviewsPage()) return null;
    var scope = document.body;
    var interactive = Array.prototype.slice.call(scope.querySelectorAll('button,a,[role="tab"],label,input[type="radio"]')).filter(function (el) { return !el.closest('.laf-review-custom-tabs'); });

    /* Find the distinctive Store/Boutique control first, then pair it with the
       neighbouring generic “Avis (N)” control. This matches Trustoo's actual
       storefront wording much more reliably than requiring “Avis produits”. */
    var store = interactive.find(function (el) {
      var t = reviewSwitchControlText(el);
      return t && t.length <= 110 && reviewSwitchStoreMatch(t);
    });
    if (!store) {
      var storeLeaf = Array.prototype.slice.call(scope.querySelectorAll('span,p,div')).find(function (el) {
        if (el.closest('.laf-review-custom-tabs') || el.children.length > 0) return false;
        var t = normalizeText(el.textContent);
        return t && t.length <= 110 && reviewSwitchStoreMatch(t);
      });
      if (storeLeaf) store = storeLeaf.closest('button,a,[role="tab"],label,[onclick]') || storeLeaf;
    }
    if (!store) return null;

    var product = interactive.find(function (el) {
      if (el === store) return false;
      var t = reviewSwitchControlText(el);
      if (!t || t.length > 110 || reviewSwitchStoreMatch(t)) return false;
      if (!reviewSwitchProductMatch(t)) return false;
      return !!closestReviewSwitchCommon(el, store);
    });

    /* Some versions put the product label in a non-interactive child. Resolve
       its nearest clickable ancestor, while keeping the store control native. */
    if (!product) {
      var leaves = Array.prototype.slice.call(scope.querySelectorAll('span,p,div')).filter(function (el) { return el.children.length === 0 && !el.closest('.laf-review-custom-tabs'); });
      var productLeaf = leaves.find(function (el) {
        var t = normalizeText(el.textContent);
        if (!reviewSwitchProductMatch(t) || reviewSwitchStoreMatch(t)) return false;
        var c = el.closest('button,a,[role="tab"],label');
        return c && !!closestReviewSwitchCommon(c, store);
      });
      if (productLeaf) product = productLeaf.closest('button,a,[role="tab"],label,[onclick]') || productLeaf;
    }
    if (!product) return null;

    var container = closestReviewSwitchCommon(product, store);
    if (!container || container === document.body || container === root) return null;
    container.classList.add('laf-review-native-switch');
    container.setAttribute('data-laf-review-switch', 'true');
    product.classList.add('laf-review-native-switch__tab','laf-review-native-switch__tab--product');
    store.classList.add('laf-review-native-switch__tab','laf-review-native-switch__tab--store');
    product.setAttribute('data-laf-tab-label','AVIS PRODUITS');
    store.setAttribute('data-laf-tab-label','AVIS BOUTIQUE');

    if (product.dataset.lafSwitchClickReady !== '1') {
      product.dataset.lafSwitchClickReady = '1';
      product.addEventListener('click', function () {
        product.classList.add('laf-tab-active');
        store.classList.remove('laf-tab-active');
      });
    }
    if (store.dataset.lafSwitchClickReady !== '1') {
      store.dataset.lafSwitchClickReady = '1';
      store.addEventListener('click', function () {
        store.classList.add('laf-tab-active');
        product.classList.remove('laf-tab-active');
      });
    }
    var nativeStoreActive = store.getAttribute('aria-selected') === 'true' || /active|selected/i.test(store.className || '');
    var nativeProductActive = product.getAttribute('aria-selected') === 'true' || /active|selected/i.test(product.className || '');
    if (nativeStoreActive) store.classList.add('laf-tab-active');
    else if (nativeProductActive || !store.classList.contains('laf-tab-active')) product.classList.add('laf-tab-active');

    clearLafHiddenFlags(container, root && root.contains(container) ? root : null);

    /* Put the native switch immediately under the LAF “TOUS LES AVIS” heading.
       Moving the existing controls keeps Trustoo's own click/data logic intact. */
    var body = root && root.querySelector('#reviews-body');
    var heading = body && body.querySelector(':scope > .laf-reviews-list-heading');
    if (body && heading) {
      var slot = body.querySelector(':scope > .laf-review-switch-slot');
      if (!slot) {
        slot = document.createElement('div');
        slot.className = 'laf-review-switch-slot';
        heading.insertAdjacentElement('afterend', slot);
      }
      if (container.parentElement !== slot) slot.appendChild(container);
    }
    return container;
  }

  function isReviewSwitchNode(node) {
    if (!node || !node.querySelector) return false;
    if (node.matches && node.matches('[data-laf-review-switch="true"],.laf-review-native-switch')) return true;
    return !!node.querySelector('[data-laf-review-switch="true"],.laf-review-native-switch');
  }


  /* V7.11.30 — always-visible LAF tabs for the dedicated reviews page.
     The native Trustoo controls remain the source of truth and stay in the DOM;
     these buttons only proxy the click so the two review types are always visible. */
  function findNativeReviewModeTarget(mode) {
    if (!isGlobalReviewsPage()) return null;
    var scope = document.body;
    var selectors = 'button,a,[role="tab"],label,input[type="radio"],[onclick],[data-type],[data-value],[data-tab]';
    var candidates = Array.prototype.slice.call(scope.querySelectorAll(selectors)).filter(function (el) {
      return !el.closest('.laf-review-custom-tabs');
    });

    function match(el) {
      var t = reviewSwitchControlText(el);
      if (!t) return false;
      return mode === 'store' ? reviewSwitchStoreMatch(t) : (reviewSwitchProductMatch(t) && !reviewSwitchStoreMatch(t));
    }

    var direct = candidates.find(match);
    if (direct) return direct;

    /* Trustoo sometimes places the label inside a generic clickable wrapper. */
    var leaves = Array.prototype.slice.call(scope.querySelectorAll('span,p,div')).filter(function (el) {
      if (el.closest('.laf-review-custom-tabs') || el.children.length > 0) return false;
      var t = normalizeText(el.textContent);
      if (!t || t.length > 120) return false;
      return mode === 'store' ? reviewSwitchStoreMatch(t) : (reviewSwitchProductMatch(t) && !reviewSwitchStoreMatch(t));
    });
    for (var i = 0; i < leaves.length; i++) {
      var clickable = leaves[i].closest('button,a,[role="tab"],label,[onclick],[data-type],[data-value],[data-tab]');
      if (clickable && !clickable.closest('.laf-review-custom-tabs')) return clickable;
    }
    return null;
  }

  function syncCustomReviewTabs(mode) {
    document.querySelectorAll('.laf-review-custom-tabs__button').forEach(function (button) {
      var active = button.getAttribute('data-laf-review-mode') === mode;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function storeReviewDisplayDate(value) {
    var m = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? (m[3] + '/' + m[2] + '/' + m[1]) : String(value || '');
  }

  function storeReviewInitials(name) {
    var parts = normalizeText(name).split(' ').filter(Boolean);
    if (!parts.length) return 'LAF';
    return parts.slice(0,2).map(function (part) { return part.charAt(0).toUpperCase(); }).join('');
  }

  function makeStoreReviewCard(review) {
    var card = document.createElement('article');
    card.className = 'laf-store-review-card laf-premium-review-unit';

    var stars = document.createElement('div');
    stars.className = 'laf-store-review-stars';
    stars.setAttribute('aria-label', String(review.rating || 0) + ' étoiles sur 5');
    for (var i=1;i<=5;i++) {
      var star = document.createElement('span');
      star.textContent = '★';
      if (i > Number(review.rating || 0)) star.className = 'is-empty';
      stars.appendChild(star);
    }
    card.appendChild(stars);

    var head = document.createElement('div');
    head.className = 'laf-store-review-head';
    var avatar = document.createElement('span');
    avatar.className = 'laf-store-review-avatar';
    avatar.textContent = storeReviewInitials(review.author);
    var author = document.createElement('strong');
    author.className = 'laf-store-review-author';
    author.textContent = review.author || 'Client LAF';
    head.appendChild(avatar);
    head.appendChild(author);
    if (review.verified) {
      var verified = document.createElement('span');
      verified.className = 'laf-global-verified-badge laf-store-review-verified';
      verified.textContent = 'Achat vérifié';
      head.appendChild(verified);
    }
    var date = document.createElement('time');
    date.className = 'laf-store-review-date';
    date.textContent = storeReviewDisplayDate(review.date);
    head.appendChild(date);
    card.appendChild(head);

    if (review.content) {
      var content = document.createElement('p');
      content.className = 'laf-store-review-content';
      content.textContent = review.content;
      card.appendChild(content);
    }

    if (review.photos && review.photos.length) {
      var photos = document.createElement('div');
      photos.className = 'img-list laf-store-review-photos';
      review.photos.forEach(function (url) {
        var img = document.createElement('img');
        img.src = url;
        img.setAttribute('data-original', url);
        img.alt = 'Photo client';
        img.loading = 'lazy';
        photos.appendChild(img);
      });
      card.appendChild(photos);
    }

    if (review.reply) {
      var reply = document.createElement('div');
      reply.className = 'laf-store-review-reply';
      var label = document.createElement('strong');
      label.textContent = 'Réponse LAF';
      var text = document.createElement('p');
      text.textContent = review.reply;
      reply.appendChild(label);
      reply.appendChild(text);
      card.appendChild(reply);
    }
    return card;
  }

  function renderStoreReviewsPage(root, page) {
    var body = root && root.querySelector('#reviews-body');
    var panel = body && body.querySelector(':scope > .laf-store-reviews-panel');
    if (!panel) return;
    var reviews = Array.isArray(window.LAF_STORE_REVIEWS) ? window.LAF_STORE_REVIEWS : [];
    var totalPages = Math.max(1, Math.ceil(reviews.length / LAF_STORE_REVIEWS_PER_PAGE));
    lafStoreReviewsPage = Math.max(1, Math.min(Number(page || 1), totalPages));
    panel.innerHTML = '';

    var meta = document.createElement('div');
    meta.className = 'laf-store-reviews-meta';
    meta.textContent = reviews.length + ' avis boutique';
    panel.appendChild(meta);

    var list = document.createElement('div');
    list.className = 'laf-store-reviews-list';
    var start = (lafStoreReviewsPage - 1) * LAF_STORE_REVIEWS_PER_PAGE;
    reviews.slice(start, start + LAF_STORE_REVIEWS_PER_PAGE).forEach(function (review) {
      list.appendChild(makeStoreReviewCard(review));
    });
    panel.appendChild(list);

    if (totalPages > 1) {
      var pager = document.createElement('nav');
      pager.className = 'laf-store-reviews-pagination';
      pager.setAttribute('aria-label','Pagination des avis boutique');

      function addButton(label, target, active, disabled) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = label;
        b.disabled = !!disabled;
        b.className = 'laf-store-reviews-page-button' + (active ? ' is-active' : '');
        b.setAttribute('data-laf-store-page', String(target));
        pager.appendChild(b);
      }
      addButton('‹', lafStoreReviewsPage - 1, false, lafStoreReviewsPage === 1);
      var first = Math.max(1, lafStoreReviewsPage - 2);
      var last = Math.min(totalPages, first + 4);
      first = Math.max(1, last - 4);
      for (var p=first;p<=last;p++) addButton(String(p), p, p === lafStoreReviewsPage, false);
      addButton('›', lafStoreReviewsPage + 1, false, lafStoreReviewsPage === totalPages);
      panel.appendChild(pager);
    }
  }

  function ensureStoreReviewsPanel(root) {
    if (!isGlobalReviewsPage() || !root) return null;
    var body = root.querySelector('#reviews-body');
    var slot = body && body.querySelector(':scope > .laf-review-switch-slot');
    if (!body || !slot) return null;
    var panel = body.querySelector(':scope > .laf-store-reviews-panel');
    if (!panel) {
      panel = document.createElement('section');
      panel.className = 'laf-store-reviews-panel';
      panel.hidden = true;
      slot.insertAdjacentElement('afterend', panel);
      panel.addEventListener('click', function (event) {
        var button = event.target.closest('[data-laf-store-page]');
        if (!button || button.disabled) return;
        event.preventDefault();
        renderStoreReviewsPage(root, Number(button.getAttribute('data-laf-store-page')) || 1);
        panel.scrollIntoView({behavior:'smooth',block:'start'});
      });
    }
    if (!panel.dataset.lafRendered) {
      panel.dataset.lafRendered = '1';
      renderStoreReviewsPage(root, 1);
    }
    return panel;
  }

  function setGlobalReviewMode(mode, root) {
    if (!isGlobalReviewsPage() || !root) return;
    lafGlobalReviewMode = mode === 'store' ? 'store' : 'product';
    syncCustomReviewTabs(lafGlobalReviewMode);
    var panel = ensureStoreReviewsPanel(root);
    if (lafGlobalReviewMode === 'store') {
      root.classList.add('laf-store-mode');
      if (panel) panel.hidden = false;
    } else {
      root.classList.remove('laf-store-mode');
      if (panel) panel.hidden = true;
    }
  }

  function ensureVisibleReviewTabs(root) {
    if (!isGlobalReviewsPage() || !root) return null;
    root.classList.add('laf-global-reviews-page');
    var body = root.querySelector('#reviews-body');
    var heading = body && body.querySelector(':scope > .laf-reviews-list-heading');
    if (!body || !heading) return null;

    var slot = body.querySelector(':scope > .laf-review-switch-slot');
    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'laf-review-switch-slot';
      heading.insertAdjacentElement('afterend', slot);
    }

    var controls = slot.querySelector('.laf-review-custom-controls');
    if (!controls) {
      controls = document.createElement('div');
      controls.className = 'laf-review-custom-controls';
      controls.innerHTML =
        '<div class="laf-review-custom-tabs" role="tablist" aria-label="Type d’avis">' +
          '<button type="button" class="laf-review-custom-tabs__button is-active" role="tab" aria-selected="true" data-laf-review-mode="product">AVIS PRODUITS</button>' +
          '<button type="button" class="laf-review-custom-tabs__button" role="tab" aria-selected="false" data-laf-review-mode="store">AVIS BOUTIQUE</button>' +
        '</div>';
      slot.appendChild(controls);
      controls.addEventListener('click', function (event) {
        var tab = event.target.closest('.laf-review-custom-tabs__button');
        if (tab) {
          event.preventDefault();
          setGlobalReviewMode(tab.getAttribute('data-laf-review-mode'), root);
          return;
        }
      });
    }

    ensureStoreReviewsPanel(root);
    setGlobalReviewMode(lafGlobalReviewMode, root);
    return controls;
  }

  function initScroll() {
    document.querySelectorAll('[data-laf-scroll-reviews]').forEach(function (control) {
      if (control.dataset.lafScrollReady === '1') return;
      control.dataset.lafScrollReady = '1';

      function goToReviews() {
        var target = document.querySelector('[data-laf-reviews-anchor]') || document.querySelector('#vstar-reviews');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      control.addEventListener('click', goToReviews);
      control.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          goToReviews();
        }
      });
    });
  }

  function cleanTrustooTitle(root) {
    root.querySelectorAll('h1,h2,h3,h4,p,div,span').forEach(function (el) {
      if (el.children.length > 0) return;
      var t = normalizeText(el.textContent).toLowerCase();
      if (t === 'avis des clients' || t === 'customer reviews') {
        el.setAttribute('data-laf-hidden-review-title', 'true');
        el.style.display = 'none';
      }
    });
  }

  function formatFrenchScores(root) {
    root.querySelectorAll('span,div,p,strong').forEach(function (el) {
      if (el.children.length > 0 || el.closest('#reviews-body')) return;
      var t = normalizeText(el.textContent);
      if (/^[0-5]\.\d$/.test(t)) {
        el.textContent = t.replace('.', ',');
      }
    });
  }

  function markSummaryScore(root) {
    var leaves = Array.prototype.slice.call(root.querySelectorAll('span,div,p,strong'));
    var scoreLeaf = leaves.find(function (el) {
      if (el.children.length > 0 || el.closest('#reviews-body')) return false;
      return /^[0-5][\.,]\d$/.test(normalizeText(el.textContent));
    });
    if (!scoreLeaf) return;

    var node = scoreLeaf;
    var best = scoreLeaf;
    for (var i = 0; i < 4 && node.parentElement && node.parentElement !== root; i++) {
      node = node.parentElement;
      var text = normalizeText(node.textContent);
      var hasBreakdown = /5\s*(étoiles|stars)/i.test(text) || /4\s*(étoiles|stars)/i.test(text);
      if (!hasBreakdown && text.length <= 24 && node.querySelectorAll('img').length === 0) {
        best = node;
      } else {
        break;
      }
    }
    best.setAttribute('data-laf-summary-score', 'true');
  }

  function findSmallestTextContainer(root, patterns) {
    var candidates = Array.prototype.slice.call(root.querySelectorAll('div,section,article,aside'))
      .filter(function (el) {
        if (el.closest('#reviews-body')) return false;
        if (el.closest('.laf-breakdown-clean,.laf-trustoo-overview')) return false;
        var text = normalizeText(el.textContent);
        return patterns.every(function (pattern) { return pattern.test(text); });
      })
      .sort(function (a, b) {
        return normalizeText(a.textContent).length - normalizeText(b.textContent).length;
      });
    return candidates[0] || null;
  }

  function leafTexts(container) {
    return Array.prototype.slice.call(container.querySelectorAll('span,div,p,strong,b,small')).filter(function (el) {
      return el.children.length === 0 && normalizeText(el.textContent);
    });
  }

  function getNativeBreakdownText(breakdown) {
    if (!breakdown) return '';

    /* Never parse the LAF rows that we generated ourselves. textContent does not
       insert spaces between neighbouring block elements, so a generated row ending
       in "211" followed by "4 étoiles" could become "2114 étoiles". On each
       MutationObserver pass that made 211 -> 2114 -> 21144 -> 211444...
       Clone the native Trustoo block, remove every LAF-generated node, then join
       each text node with an explicit space so labels and counts stay separated. */
    var source = breakdown.cloneNode(true);
    source.querySelectorAll('.laf-breakdown-clean,.laf-trustoo-mini-title').forEach(function (el) {
      el.remove();
    });

    var tokens = [];
    var walker = document.createTreeWalker(source, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var token = normalizeText(node.nodeValue);
      if (token) tokens.push(token);
    }
    return tokens.join(' ');
  }

  function buildCleanBreakdown(breakdown) {
    if (!breakdown) return;

    /* Trustoo changes its internal markup regularly. Parse only the native Trustoo
       text instead of depending on a specific row structure. Example:
       "5 étoiles 211 4 étoiles 7 3 étoiles 1 2 étoiles 0 1 étoile 0". */
    var text = getNativeBreakdownText(breakdown);
    var counts = {};
    var re = /([1-5])\s*(?:étoile|étoiles|star|stars)\s*(\d+)/gi;
    var m;
    while ((m = re.exec(text)) !== null) counts[parseInt(m[1], 10)] = parseInt(m[2], 10);

    /* Fallback for layouts where the number is placed before the label. */
    if (Object.keys(counts).length < 3) {
      var re2 = /(\d+)\s*([1-5])\s*(?:étoile|étoiles|star|stars)/gi;
      while ((m = re2.exec(text)) !== null) counts[parseInt(m[2], 10)] = parseInt(m[1], 10);
    }

    if (Object.keys(counts).length < 3) return;
    var ordered = [5,4,3,2,1].map(function (star) { return {star:star,count:counts[star] == null ? 0 : counts[star]}; });
    var total = ordered.reduce(function (sum, r) { return sum + r.count; }, 0) || 1;
    var signature = ordered.map(function (row) { return row.star + ':' + row.count; }).join('|');

    Array.prototype.slice.call(breakdown.children).forEach(function (child) {
      if (!child.classList.contains('laf-trustoo-mini-title') && !child.classList.contains('laf-breakdown-clean')) child.classList.add('laf-breakdown-original');
    });

    var clean = breakdown.querySelector(':scope > .laf-breakdown-clean');
    if (!clean) {
      clean = document.createElement('div');
      clean.className = 'laf-breakdown-clean';
      breakdown.appendChild(clean);
    }

    /* MutationObserver calls this decorator again whenever Trustoo changes.
       Do not rebuild an identical breakdown: rebuilding it would itself trigger
       another mutation and could make the generated breakdown get detected again. */
    if (clean.getAttribute('data-laf-breakdown-signature') === signature) return;
    clean.setAttribute('data-laf-breakdown-signature', signature);
    clean.innerHTML = '';

    ordered.forEach(function (row) {
      var pct = Math.max(0, Math.min(100, (row.count / total) * 100));
      var line = document.createElement('div');
      line.className = 'laf-breakdown-row';
      line.innerHTML = '<span class="laf-breakdown-row__label">' + row.star + ' étoile' + (row.star > 1 ? 's' : '') + '</span>' +
        '<span class="laf-breakdown-row__track"><span class="laf-breakdown-row__fill" style="--laf-bar:' + pct.toFixed(2) + '%"></span></span>' +
        '<span class="laf-breakdown-row__count">' + row.count + '</span>';
      clean.appendChild(line);
    });
  }

  function markBreakdown(root) {
    /* Once identified, keep using the same native Trustoo block. Without this
       guard, our own generated .laf-breakdown-clean also matches "5 étoiles /
       4 étoiles" and can be selected on the next MutationObserver pass, creating
       nested copies of the rating distribution. */
    var breakdown = root.querySelector('.laf-trustoo-breakdown');
    if (!breakdown) {
      breakdown = findSmallestTextContainer(root, [/(5\s*(étoiles|stars))/i, /(4\s*(étoiles|stars))/i]);
    }
    if (!breakdown) return null;
    breakdown.classList.add('laf-trustoo-breakdown');
    if (!breakdown.querySelector(':scope > .laf-trustoo-mini-title')) {
      var title = document.createElement('div');
      title.className = 'laf-trustoo-mini-title';
      title.textContent = 'RÉPARTITION DES NOTES';
      breakdown.insertBefore(title, breakdown.firstChild);
    }
    buildCleanBreakdown(breakdown);
    return breakdown;
  }

  function candidateDepth(el, root) {
    var depth = 0;
    while (el && el !== root) {
      depth += 1;
      el = el.parentElement;
    }
    return depth;
  }

  function tileForImage(img, gallery) {
    var current = img;
    var previous = img;
    while (current && current !== gallery) {
      var count = current.querySelectorAll ? current.querySelectorAll('img').length : 0;
      if (count > 1) return previous;
      previous = current;
      current = current.parentElement;
    }
    return previous;
  }

  function markGallery(root) {
    var images = Array.prototype.slice.call(root.querySelectorAll('img')).filter(function (img) {
      if (img.closest('#reviews-body')) return false;
      if (!img.getAttribute('src')) return false;
      var rect = img.getBoundingClientRect();
      return rect.width >= 28 && rect.height >= 28;
    });
    if (images.length < 2) return null;

    var candidates = [];
    images.forEach(function (img) {
      var node = img.parentElement;
      for (var i = 0; i < 6 && node && node !== root; i++) {
        var imgs = Array.prototype.slice.call(node.querySelectorAll('img')).filter(function (child) { return !child.closest('#reviews-body'); });
        if (imgs.length >= 2 && imgs.length <= 12) candidates.push({el:node,count:imgs.length,depth:candidateDepth(node,root),textLength:normalizeText(node.textContent).length});
        node = node.parentElement;
      }
    });
    if (!candidates.length) return null;
    candidates.sort(function (a,b) { if (b.count !== a.count) return b.count-a.count; if (b.depth !== a.depth) return b.depth-a.depth; return a.textLength-b.textLength; });
    var gallery = candidates[0].el;
    gallery.classList.add('laf-trustoo-gallery');
    if (!gallery.querySelector(':scope > .laf-trustoo-mini-title')) {
      var title = document.createElement('div');
      title.className = 'laf-trustoo-mini-title';
      title.textContent = 'PORTÉ PAR VOUS';
      gallery.insertBefore(title, gallery.firstChild);
    }

    var galleryImages = Array.prototype.slice.call(gallery.querySelectorAll('img')).filter(function (img) { return !img.closest('#reviews-body'); });
    var tiles = [];
    galleryImages.forEach(function (img) {
      var tile = tileForImage(img, gallery);
      if (tile && tile !== gallery && tiles.indexOf(tile) === -1) tiles.push(tile);
    });
    tiles.forEach(function (tile) {
      tile.classList.add('laf-gallery-tile');
      if (tile.parentElement !== gallery) gallery.appendChild(tile);
    });
    return gallery;
  }

  function markVerifiedBadges(card) {
    var nodes = Array.prototype.slice.call(card.querySelectorAll('span,div,p,strong,em'));
    nodes.forEach(function (el) {
      var t = normalizeText(el.textContent);
      if (!t || t.length > 50) return;
      if (/^(verified|verified buyer|verified purchase|vérifié|achat vérifié|acheteur vérifié)$/i.test(t)) {
        el.classList.add('laf-verified-badge');
        if (el.children.length === 0) el.textContent = '✓ ACHAT VÉRIFIÉ';
      }
    });
  }

  function decorateReviewCard(card) {
    if (!card) return;
    card.classList.add('laf-review-card');
    markVerifiedBadges(card);
    if (card.querySelector('.img-list img, img')) card.classList.add('laf-review-card--with-photo');

    /* Stable hook for the Trustoo date. */
    Array.prototype.slice.call(card.querySelectorAll('span,div,p,time')).forEach(function (el) {
      var t = normalizeText(el.textContent);
      if (/^\d{1,2}[\/.-]\d{1,2}[\/.-]\d{4}$/.test(t) && el.children.length === 0) {
        el.classList.add('laf-review-date');
      }
    });

    /* Replace the native variant label/value with a compact LAF block. */
    if (!card.querySelector('.laf-review-variant-block')) {
      var nodes = Array.prototype.slice.call(card.querySelectorAll('span,div,p,small'));
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.closest('.laf-review-variant-block')) continue;
        var t = normalizeText(el.textContent);
        if (!/^type d[’']article\s*:?$/i.test(t)) continue;
        var value = el.nextElementSibling;
        while (value && !normalizeText(value.textContent)) value = value.nextElementSibling;
        if (!value) continue;
        var valueText = normalizeText(value.textContent);
        if (!valueText || valueText.length > 180) continue;

        var block = document.createElement('div');
        block.className = 'laf-review-variant-block';
        var label = document.createElement('span');
        label.className = 'laf-review-variant-label';
        label.textContent = 'VARIANTE ACHETÉE';
        var val = document.createElement('span');
        val.className = 'laf-review-variant-value';
        val.textContent = valueText;
        block.appendChild(label);
        block.appendChild(val);
        el.setAttribute('data-laf-variant-original', 'true');
        value.setAttribute('data-laf-variant-original', 'true');
        value.parentElement.insertBefore(block, value.nextSibling);
        break;
      }
    }

    /* Helpful controls remain functional, but are visually secondary. */
    Array.prototype.slice.call(card.querySelectorAll('span,div,p')).forEach(function (el) {
      var t = normalizeText(el.textContent);
      if (/^utile\s*\?/i.test(t) && t.length < 100) el.classList.add('laf-review-helpful');
    });

    /* V7.11.15 — short text-only reviews become genuinely compact.
       Trustoo can keep internal wrappers with minimum heights even when the outer
       card itself is height:auto. Measure only the useful review copy (excluding
       date, badge, variant, helpful controls and stars), then add a stable class
       only to short reviews without customer photos. */
    var compactClone = card.cloneNode(true);
    compactClone.querySelectorAll(
      '.laf-review-date,.laf-verified-badge,.laf-review-variant-block,.laf-review-helpful,' +
      '[data-laf-variant-original="true"],.star,svg,button'
    ).forEach(function (el) { el.remove(); });
    var compactText = normalizeText(compactClone.textContent);
    var hasCustomerPhoto = !!card.querySelector('.img-list img, img');
    if (!hasCustomerPhoto && compactText.length <= 160) card.classList.add('laf-review-card--compact');
    else card.classList.remove('laf-review-card--compact');
  }

  function markReviewCards(root) {
    root.querySelectorAll('#reviews-body .list-review-body-item, .list-review-body-item').forEach(function (card) {
      decorateReviewCard(card);
    });
  }


  /* V7.11.11 — apply the purchased-variant treatment to EVERY review.
     Trustoo can split a review across several nested/sibling blocks, so limiting
     the search to the detected card means only the first visible review may get
     upgraded. This pass works on the full reviews body and is idempotent. */
  function decorateAllReviewVariants(body) {
    if (!body) return;
    var nodes = Array.prototype.slice.call(body.querySelectorAll('span,div,p,small'));
    nodes.forEach(function (el) {
      if (!el || el.getAttribute('data-laf-variant-original') === 'true') return;
      if (el.closest('.laf-review-variant-block')) return;
      if (el.children.length > 0) return;
      var t = normalizeText(el.textContent);
      if (!/^type d[’']article\s*:?$/i.test(t)) return;

      var value = el.nextElementSibling;
      while (value && (!normalizeText(value.textContent) || value.getAttribute('data-laf-variant-original') === 'true')) {
        value = value.nextElementSibling;
      }

      /* Fallback: in some Trustoo renders the value sits in the same parent but
         after an extra wrapper. Use the next meaningful sibling of the label's
         parent before giving up. */
      if (!value && el.parentElement) {
        var parentNext = el.parentElement.nextElementSibling;
        while (parentNext && !normalizeText(parentNext.textContent)) parentNext = parentNext.nextElementSibling;
        if (parentNext) value = parentNext;
      }

      if (!value) return;
      var valueText = normalizeText(value.textContent);
      if (!valueText || valueText.length > 180 || /^utile\s*\?/i.test(valueText)) return;

      /* Avoid creating a second block if this exact value was already decorated. */
      var host = value.parentElement || el.parentElement || body;
      var existing = host.querySelector && host.querySelector('.laf-review-variant-block[data-laf-variant-value="' + valueText.replace(/"/g, '&quot;') + '"]');
      if (existing) {
        el.setAttribute('data-laf-variant-original', 'true');
        value.setAttribute('data-laf-variant-original', 'true');
        return;
      }

      var block = document.createElement('div');
      block.className = 'laf-review-variant-block';
      block.setAttribute('data-laf-variant-value', valueText);
      var label = document.createElement('span');
      label.className = 'laf-review-variant-label';
      label.textContent = 'VARIANTE ACHETÉE';
      var val = document.createElement('span');
      val.className = 'laf-review-variant-value';
      val.textContent = valueText;
      block.appendChild(label);
      block.appendChild(val);

      el.setAttribute('data-laf-variant-original', 'true');
      value.setAttribute('data-laf-variant-original', 'true');
      if (value.parentElement) value.parentElement.insertBefore(block, value.nextSibling);
    });
  }

  function meaningfulContent(el) {
    if (!el) return false;
    if (normalizeText(el.textContent)) return true;
    return !!el.querySelector('img,button,a,input,textarea,svg,#reviews-body');
  }

  function collapseAncestors(ancestors, root) {
    ancestors.forEach(function (el) {
      if (!el || el === root || el.contains(root) || el.classList.contains('laf-trustoo-overview')) return;
      if (!meaningfulContent(el)) el.setAttribute('data-laf-empty-shell', 'true');
    });
  }

  function ancestorChain(el, root) {
    var arr = [];
    var node = el && el.parentElement;
    while (node && node !== root) { arr.push(node); node = node.parentElement; }
    return arr;
  }

  function findWriteControl(root) {
    return Array.prototype.slice.call(root.querySelectorAll('button,a')).find(function (el) {
      /* Ignore LAF navigation controls on the dedicated reviews page. */
      if (el.closest('.laf-review-custom-controls')) return false;
      var t = normalizeText(el.textContent);
      return /^(écrire un commentaire|écrire un avis|laisser un avis|write a review|write a comment)$/i.test(t);
    }) || null;
  }

  function arrangeOverview(root, breakdown, gallery) {
    if (!breakdown && !gallery) return;
    var overview = root.querySelector('.laf-trustoo-overview');
    if (!overview) {
      overview = document.createElement('div');
      overview.className = 'laf-trustoo-overview';
      var body = root.querySelector('#reviews-body');
      if (body) root.insertBefore(overview, body); else root.appendChild(overview);
    }
    var ancestors = [];
    [breakdown, gallery].forEach(function (el) {
      if (!el || el.parentElement === overview) return;
      ancestors = ancestors.concat(ancestorChain(el, root));
      overview.appendChild(el);
    });
    collapseAncestors(ancestors, root);
  }

  function closestCommonAncestor(nodes, stopAt) {
    if (!nodes.length) return null;
    var chain = [];
    var n = nodes[0];
    while (n && n !== stopAt) { chain.push(n); n = n.parentElement; }
    if (stopAt) chain.push(stopAt);
    for (var i = 0; i < chain.length; i++) {
      var candidate = chain[i];
      if (nodes.every(function (node) { return candidate.contains(node); })) return candidate;
    }
    return stopAt || null;
  }

  function markNativeReviewGrid(body) {
    var cards = Array.prototype.slice.call(body.querySelectorAll('.list-review-body-item'));
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.classList.add('laf-review-card');
      markVerifiedBadges(card);
      if (card.querySelector('.img-list img, img')) card.classList.add('laf-review-card--with-photo');
    });

    var common = closestCommonAncestor(cards, body);
    if (!common) return;

    /* Prefer the native list container. If the common ancestor is too high,
       use the closest parent shared by the majority of review cards. */
    if (common === body) {
      var parents = [];
      cards.forEach(function (card) { if (card.parentElement && parents.indexOf(card.parentElement) === -1) parents.push(card.parentElement); });
      var best = parents.sort(function (a,b) {
        return b.querySelectorAll('.list-review-body-item').length - a.querySelectorAll('.list-review-body-item').length;
      })[0];
      if (best && best.querySelectorAll('.list-review-body-item').length >= Math.min(2, cards.length)) common = best;
    }

    common.classList.add('laf-reviews-card-grid-native');

    /* Mark the direct child that owns each review so the grid works even when
       Trustoo wraps reviews in an extra div. */
    cards.forEach(function (card) {
      var item = card;
      while (item.parentElement && item.parentElement !== common) item = item.parentElement;
      if (item && item !== common) item.classList.add('laf-review-grid-item');
    });
  }

  /* V7.11.25 — protect Trustoo's native pagination from LAF cleanup. */
  function isTrustooFooterNode(node) {
    if (!node || !node.querySelector) return false;
    if (node.id === 'reviews-footer') return true;
    if (node.matches && node.matches('#reviews-footer,[class*="pagination" i],[class*="pager" i]')) return true;
    return !!node.querySelector('#reviews-footer,[class*="pagination" i],[class*="pager" i]');
  }

  function restoreTrustooFooter(root) {
    if (!root) return;
    var footer = root.querySelector('#reviews-footer');
    if (!footer) return;
    footer.classList.add('laf-reviews-footer');
    footer.removeAttribute('data-laf-native-summary-shell');
    footer.removeAttribute('data-laf-orphan-summary');
    footer.removeAttribute('data-laf-empty-shell');
    var node = footer.parentElement;
    while (node && node !== root) {
      node.removeAttribute('data-laf-native-summary-shell');
      node.removeAttribute('data-laf-orphan-summary');
      node.removeAttribute('data-laf-empty-shell');
      node = node.parentElement;
    }
  }

  function hideNativeSummaryShells(root, overview, body) {
    Array.prototype.slice.call(root.children).forEach(function (child) {
      if (child === overview || child === body || child.contains(overview) || child.contains(body)) return;
      if (isTrustooFooterNode(child) || isReviewSwitchNode(child)) return;
      if (child.matches && child.matches('[role="dialog"],dialog,.modal,[class*="modal"],[class*="popup"]')) return;
      var txt = normalizeText(child.textContent);
      var hasForm = !!child.querySelector('form,textarea,input');
      if (!hasForm && txt.length < 80) child.setAttribute('data-laf-native-summary-shell','true');
    });
  }

  function markReviewBody(root) {
    var body = root.querySelector('#reviews-body');
    if (!body) return;
    body.classList.add('laf-reviews-grid');

    var heading = body.querySelector(':scope > .laf-reviews-list-heading');
    if (!heading) {
      heading = document.createElement('div');
      heading.className = 'laf-reviews-list-heading';
      var h = document.createElement('h3');
      h.className = 'laf-reviews-list-heading__title';
      h.textContent = 'TOUS LES AVIS';
      heading.appendChild(h);
      body.insertBefore(heading, body.firstChild);
    }

    var write = findWriteControl(root);
    if (write && !heading.contains(write)) {
      var wrap = heading.querySelector('.laf-reviews-write-wrap');
      if (!wrap) { wrap = document.createElement('div'); wrap.className = 'laf-reviews-write-wrap'; heading.appendChild(wrap); }
      wrap.appendChild(write);
    }

    /* We keep Trustoo's native list logic intact and wrap each real review below. */
  }





  function findHeuristicReviewCards(body) {
    if (!body) return [];
    var results = [];
    var dateRe = /^\d{1,2}[\/.\-]\d{1,2}[\/.\-]\d{4}$/;

    function pushUnique(el) {
      if (!el || el === body || results.indexOf(el) !== -1) return;
      results.push(el);
    }

    function reviewScore(text, node) {
      var score = 0;
      if (/(achat vérifié|acheteur vérifié|verified)/i.test(text)) score += 2;
      if (/type d[’']article/i.test(text)) score += 3;
      if (/(utile\s*\?|helpful)/i.test(text)) score += 3;
      if (node && node.querySelector && node.querySelector('img')) score += 1;
      /* A genuine review body normally has some free text in addition to metadata. */
      if (text.length > 90) score += 1;
      return score;
    }

    /* Trustoo splits a review into several sibling blocks. Starting from the date,
       climb until we find the ONE ancestor that contains the header + review text +
       purchased variant/helpful controls. Do not stop at the small author header. */
    Array.prototype.slice.call(body.querySelectorAll('time,span,div,p,small')).forEach(function (leaf) {
      if (leaf.children.length > 0) return;
      var dateText = normalizeText(leaf.textContent);
      if (!dateRe.test(dateText)) return;

      var node = leaf.parentElement;
      var best = null;
      var bestScore = -1;
      for (var depth = 0; depth < 12 && node && node !== body; depth++, node = node.parentElement) {
        var text = normalizeText(node.textContent);
        if (!text || text.length > 8000) break;
        var dates = text.match(/\b\d{1,2}[\/.\-]\d{1,2}[\/.\-]\d{4}\b/g) || [];
        if (dates.length > 1) break;
        var score = reviewScore(text, node);
        if (score > bestScore) {
          best = node;
          bestScore = score;
        }
        /* Variant + helpful is the strongest signal that we reached the full review. */
        if (/type d[’']article/i.test(text) && /(utile\s*\?|helpful)/i.test(text)) {
          best = node;
          bestScore = score + 10;
        }
      }
      if (best && bestScore >= 4) pushUnique(best);
    });

    /* Fallback for reviews without a visible date. Prefer an ancestor containing
       both the purchased variant and helpful controls, not merely the badge row. */
    Array.prototype.slice.call(body.querySelectorAll('span,div,p,strong,small')).forEach(function (leaf) {
      if (leaf.children.length > 0) return;
      var t = normalizeText(leaf.textContent);
      if (!/^(achat vérifié|acheteur vérifié|verified|verified buyer|verified purchase)$/i.test(t)) return;
      var node = leaf.parentElement;
      var best = null;
      var bestScore = -1;
      for (var depth = 0; depth < 12 && node && node !== body; depth++, node = node.parentElement) {
        var text = normalizeText(node.textContent);
        if (!text || text.length > 8000) break;
        var score = reviewScore(text, node);
        if (score > bestScore) { best = node; bestScore = score; }
        if (/type d[’']article/i.test(text) && /(utile\s*\?|helpful)/i.test(text)) { best = node; bestScore = score + 10; }
      }
      if (best && bestScore >= 4) pushUnique(best);
    });

    /* If candidates overlap, keep the OUTER one: Trustoo's inner author block is
       not the full review and was the reason the text/variant sat outside the card. */
    return results.filter(function (candidate) {
      return !results.some(function (other) {
        return other !== candidate && other.contains(candidate);
      });
    });
  }

  function decorateHeuristicReviewCards(body) {
    var cards = findHeuristicReviewCards(body);
    cards.forEach(function (card) {
      /* Remove card styling from Trustoo's nested author/header fragments so only
         the full review receives the white LAF card. */
      Array.prototype.slice.call(card.querySelectorAll('.laf-premium-review-card-direct,.laf-review-card')).forEach(function (inner) {
        if (inner === card) return;
        inner.classList.remove('laf-premium-review-card-direct');
        inner.classList.remove('laf-review-card');
      });
      card.classList.add('laf-premium-review-card-direct');
      decorateReviewCard(card);
    });
    return cards.length;
  }

  function buildPremiumReviewList(body) {
    if (!body) return;
    var cards = Array.prototype.slice.call(body.querySelectorAll('.list-review-body-item'));
    if (!cards.length) return;

    var list = body.querySelector(':scope > .laf-premium-review-list');
    if (!list) {
      list = document.createElement('div');
      list.className = 'laf-premium-review-list';
      var heading = body.querySelector(':scope > .laf-reviews-list-heading');
      if (heading && heading.nextSibling) body.insertBefore(list, heading.nextSibling);
      else if (heading) body.appendChild(list);
      else body.insertBefore(list, body.firstChild);
    }

    cards.forEach(function (card) {
      decorateReviewCard(card);
      var wrapper = card.closest('.laf-premium-review-card');
      if (!wrapper) {
        var oldAncestors = ancestorChain(card, body);
        wrapper = document.createElement('article');
        wrapper.className = 'laf-premium-review-card';
        list.appendChild(wrapper);
        wrapper.appendChild(card);
        collapseAncestors(oldAncestors, body);
      } else if (wrapper.parentElement !== list) {
        list.appendChild(wrapper);
      }
    });
  }

  function hideOrphanSummaryBlocks(root, overview, body) {
    if (!root || !overview || !body) return;
    Array.prototype.slice.call(root.children).forEach(function (child) {
      if (child === overview || child === body || child.contains(overview) || child.contains(body)) return;
      if (isTrustooFooterNode(child) || isReviewSwitchNode(child)) return;
      if (child.matches && child.matches('[role="dialog"],dialog,.modal,[class*="modal"],[class*="popup"]')) return;
      if (child.querySelector && child.querySelector('form,textarea,input')) return;
      /* After moving the rating breakdown/gallery/write control, Trustoo leaves a
         tall summary shell containing only separators and an icon button. It has
         no useful review content anymore, so remove it deterministically. */
      var hasReview = !!child.querySelector('.list-review-body-item,#reviews-body');
      var hasCustomerPhoto = !!child.querySelector('.laf-trustoo-gallery,.laf-gallery-tile');
      var hasBreakdown = !!child.querySelector('.laf-trustoo-breakdown,.laf-breakdown-clean');
      if (!hasReview && !hasCustomerPhoto && !hasBreakdown) child.setAttribute('data-laf-orphan-summary','true');
    });
  }



  /* V7.11.14 — identify each review from its own date anchor, then climb only
     while the ancestor still belongs to that single review. This avoids styling
     Trustoo's list wrapper as one giant card when the app changes its classes. */
  function getReviewDateAnchors(body) {
    if (!body) return [];
    var dateRe = /^\d{1,2}[\/.\-]\d{1,2}[\/.\-]\d{4}$/;
    var anchors = [];
    Array.prototype.slice.call(body.querySelectorAll('time,span,div,p,small')).forEach(function (el) {
      if (el.children.length > 0) return;
      if (el.closest && el.closest('.laf-store-reviews-panel')) return;
      if (!dateRe.test(normalizeText(el.textContent))) return;
      if (anchors.indexOf(el) === -1) anchors.push(el);
    });
    return anchors;
  }

  function highestSingleReviewAncestor(anchor, anchors, body) {
    if (!anchor || !body) return null;
    var node = anchor;
    var best = anchor.parentElement;
    while (node && node.parentElement && node.parentElement !== body) {
      var parent = node.parentElement;
      var contained = 0;
      for (var i = 0; i < anchors.length; i++) {
        if (parent.contains(anchors[i])) contained += 1;
        if (contained > 1) break;
      }
      if (contained !== 1) break;

      /* Do not absorb the custom section heading/write button into a review. */
      if (parent.querySelector && parent.querySelector(':scope > .laf-reviews-list-heading')) break;
      best = parent;
      node = parent;
    }
    return best && best !== body ? best : null;
  }

  function decorateStableReviewUnits(body) {
    if (!body) return 0;
    var anchors = getReviewDateAnchors(body);
    if (!anchors.length) return 0;

    var units = [];
    anchors.forEach(function (anchor) {
      var unit = highestSingleReviewAncestor(anchor, anchors, body);
      if (!unit || unit === body) return;
      if (units.indexOf(unit) === -1) units.push(unit);
    });

    /* If Trustoo exposes one broad list shell with the legacy item class, strip
       the old card treatment from that shell. Only one-review units get cards. */
    Array.prototype.slice.call(body.querySelectorAll('.list-review-body-item,.laf-premium-review-card-direct,.laf-review-card')).forEach(function (el) {
      var count = 0;
      anchors.forEach(function (anchor) { if (el.contains(anchor)) count += 1; });
      if (count > 1) {
        el.classList.add('laf-review-list-shell');
        el.classList.remove('laf-premium-review-card-direct');
        el.classList.remove('laf-review-card');
      }
    });

    /* Avoid nested cards if a previous decoration pass touched an inner header. */
    units.forEach(function (unit) {
      Array.prototype.slice.call(unit.querySelectorAll('.laf-premium-review-unit,.laf-premium-review-card-direct,.laf-review-card')).forEach(function (inner) {
        if (inner === unit) return;
        inner.classList.remove('laf-premium-review-unit');
        inner.classList.remove('laf-premium-review-card-direct');
        inner.classList.remove('laf-review-card');
      });
      unit.classList.remove('laf-review-list-shell');
      unit.classList.add('laf-premium-review-unit');
      decorateReviewCard(unit);
    });

    return units.length;
  }




  /* V7.11.28 — on Trustoo's dedicated reviews page, keep the product-page
     behaviour: a customer photo opens a large review viewer. We never intercept
     product pages. First let Trustoo's own click handler run; only if no native
     viewer appears do we open the LAF fallback with the same large-photo + full-
     review layout. */
  var lafGlobalPhotoBridgeReady = false;
  var lafGlobalPhotoBridgeGuard = false;
  var lafGlobalViewerState = { images: [], index: 0, card: null, trigger: null };
  var lafGlobalReviewMode = 'product';
  var lafStoreReviewsPage = 1;
  var LAF_STORE_REVIEWS_PER_PAGE = 10;

  function normalizeReviewImageUrl(value) {
    var raw = (value || '').replace(/&amp;/g,'&').trim();
    if (!raw || /^data:/i.test(raw) || /^blob:/i.test(raw)) return raw;
    try {
      var u = new URL(raw, window.location.href);
      /* Trustoo's image CDN serves the original asset at the clean pathname.
         Thumbnail/currentSrc URLs can append resize/quality transforms; remove
         them so the popup uses the same full-resolution source as the native
         product-page viewer. */
      if (/^(?:img\.)?trustoo\.io$/i.test(u.hostname) || /(?:^|\.)vstar\.app$/i.test(u.hostname)) {
        u.search = '';
        u.hash = '';
        return u.href;
      }
      return u.href;
    } catch (e) {
      return raw;
    }
  }

  function bestSrcsetCandidate(srcset) {
    var entries = (srcset || '').split(',').map(function (part) {
      var bits = part.trim().split(/\s+/);
      var score = 0;
      if (bits[1]) {
        var m = bits[1].match(/([\d.]+)(w|x)/i);
        if (m) score = parseFloat(m[1]) * (m[2].toLowerCase() === 'x' ? 10000 : 1);
      }
      return { url: bits[0] || '', score: score };
    }).filter(function (x) { return x.url; });
    entries.sort(function (a,b) { return b.score - a.score; });
    return entries.length ? entries[0].url : '';
  }

  function globalReviewPhotoSource(img) {
    if (!img) return '';
    var candidates = [];
    function push(value) { if (value && candidates.indexOf(value) === -1) candidates.push(value); }

    /* Explicit full/original attributes first. */
    ['data-original','data-origin','data-full','data-full-src','data-image-url','data-url'].forEach(function (name) { push(img.getAttribute(name)); });
    var link = img.closest && img.closest('a[href]');
    if (link) push(link.getAttribute('href'));

    /* `src` is intentionally preferred over `currentSrc`: browsers often set
       currentSrc to a small responsive thumbnail while Trustoo keeps the clean
       full-resolution CDN URL in src. */
    push(img.getAttribute('src'));
    push(bestSrcsetCandidate(img.getAttribute('srcset')));
    push(img.getAttribute('data-src'));
    push(img.currentSrc);

    /* Trustoo sometimes stores the original URL on a nearby wrapper. */
    var node = img.parentElement;
    for (var depth = 0; depth < 3 && node; depth++, node = node.parentElement) {
      Array.prototype.slice.call(node.attributes || []).forEach(function (attr) {
        if (/(?:src|image|photo|original|full|url|href)/i.test(attr.name) && /(?:https?:)?\/\//i.test(attr.value || '')) push(attr.value);
      });
    }

    var imageLike = candidates.filter(function (url) { return /\.(?:jpe?g|png|webp|gif|avif)(?:[?#].*)?$/i.test(url || '') || /img\.trustoo\.io/i.test(url || ''); });
    var chosen = imageLike[0] || candidates[0] || '';
    return normalizeReviewImageUrl(chosen);
  }

  function isGlobalCustomerPhoto(img) {
    if (!isGlobalReviewsPage() || !img || img.tagName !== 'IMG') return false;
    if (!img.closest('#reviews-body,.laf-trustoo-gallery')) return false;
    var signature = [img.className || '', img.alt || '', img.getAttribute('src') || '', img.parentElement ? img.parentElement.className || '' : ''].join(' ').toLowerCase();
    if (/(avatar|profile|author|star|rating|verified|badge|icon|logo|product[-_ ]?(image|thumb|photo))/i.test(signature)) return false;
    if (img.closest('.laf-trustoo-gallery,.img-list,[class*="review-photo" i],[class*="review-image" i],[class*="resource" i]')) return true;
    var card = img.closest('.laf-premium-review-unit,.laf-review-card,.laf-premium-review-card-direct,.list-review-body-item,.laf-store-review-card');
    if (!card) return false;
    var w = img.naturalWidth || parseFloat(img.getAttribute('width') || 0);
    var h = img.naturalHeight || parseFloat(img.getAttribute('height') || 0);
    if (w && h && Math.max(w,h) < 70) return false;
    return !!globalReviewPhotoSource(img);
  }

  function visibleTrustooPhotoViewer() {
    var selector = 'dialog,[role="dialog"],[class*="modal" i],[class*="popup" i],body > div';
    var nodes = Array.prototype.slice.call(document.querySelectorAll(selector));
    return nodes.some(function (el) {
      if (el.classList.contains('laf-global-review-viewer')) return false;
      if (el.id === 'vstar-reviews' || el.classList.contains('trustoo-reviews-wrapper')) return false;
      var r = el.getBoundingClientRect();
      if (r.width < 420 || r.height < 300) return false;
      var st = window.getComputedStyle(el);
      if (st.display === 'none' || st.visibility === 'hidden' || parseFloat(st.opacity || '1') === 0) return false;
      var explicitDialog = el.matches && el.matches('dialog,[role="dialog"],[class*="modal" i],[class*="popup" i]');
      var fixedLargeOverlay = (st.position === 'fixed' || st.position === 'absolute') && r.width >= window.innerWidth * .45 && r.height >= window.innerHeight * .35;
      return (explicitDialog || fixedLargeOverlay) && !!el.querySelector('img');
    });
  }

  function cardForGlobalPhoto(img) {
    var direct = img.closest && img.closest('.laf-premium-review-unit,.laf-review-card,.laf-premium-review-card-direct,.list-review-body-item,.laf-store-review-card');
    if (direct) return direct;
    var src = (globalReviewPhotoSource(img) || '').split('?')[0];
    var body = document.querySelector('#reviews-body');
    if (!src || !body) return null;
    var match = Array.prototype.slice.call(body.querySelectorAll('img')).find(function (candidate) {
      return (globalReviewPhotoSource(candidate) || '').split('?')[0] === src && candidate !== img;
    });
    return match ? match.closest('.laf-premium-review-unit,.laf-review-card,.laf-premium-review-card-direct,.list-review-body-item,.laf-store-review-card') : null;
  }

  function globalPhotoGroup(img, card) {
    var scope = card || img.closest('.laf-trustoo-gallery') || img.parentElement;
    if (!scope) return [img];
    var list = Array.prototype.slice.call(scope.querySelectorAll('img')).filter(isGlobalCustomerPhoto);
    if (!list.length && img.closest('.laf-trustoo-gallery')) list = Array.prototype.slice.call(img.closest('.laf-trustoo-gallery').querySelectorAll('img')).filter(isGlobalCustomerPhoto);
    return list.length ? list : [img];
  }

  function ensureGlobalReviewViewer() {
    var existing = document.querySelector('.laf-global-review-viewer');
    if (existing) return existing;
    var viewer = document.createElement('div');
    viewer.className = 'laf-global-review-viewer';
    viewer.setAttribute('role','dialog');
    viewer.setAttribute('aria-modal','true');
    viewer.setAttribute('aria-hidden','true');
    viewer.innerHTML =
      '<div class="laf-global-review-viewer__backdrop" data-laf-global-close></div>' +
      '<div class="laf-global-review-viewer__panel">' +
        '<div class="laf-global-review-viewer__media">' +
          '<button type="button" class="laf-global-review-viewer__close" data-laf-global-close aria-label="Fermer">×</button>' +
          '<button type="button" class="laf-global-review-viewer__nav laf-global-review-viewer__nav--prev" data-laf-global-prev aria-label="Photo précédente">‹</button>' +
          '<img class="laf-global-review-viewer__image" alt="Photo client agrandie">' +
          '<button type="button" class="laf-global-review-viewer__nav laf-global-review-viewer__nav--next" data-laf-global-next aria-label="Photo suivante">›</button>' +
        '</div>' +
        '<div class="laf-global-review-viewer__details"></div>' +
      '</div>';
    document.body.appendChild(viewer);
    return viewer;
  }

  function cleanViewerCardClone(card) {
    if (!card) return null;
    var clone = card.cloneNode(true);
    clone.classList.add('laf-global-review-viewer__review');
    clone.removeAttribute('style');
    clone.querySelectorAll('img,.img-list,.laf-review-helpful,button,[data-laf-review-helpful],.laf-review-variant-block').forEach(function (el) { el.remove(); });
    clone.querySelectorAll('[data-laf-variant-original="true"]').forEach(function (el) { el.removeAttribute('data-laf-variant-original'); });
    clone.querySelectorAll('[style]').forEach(function (el) { el.removeAttribute('style'); });

    /* The viewer lives outside #vstar-reviews, so Trustoo/LAF scoped badge CSS
       does not follow the cloned review. Normalize the verified label and give
       it its own native-looking icon instead of a text checkmark. */
    Array.prototype.slice.call(clone.querySelectorAll('.laf-verified-badge,span,div,p,strong')).forEach(function (el) {
      if (el.children.length > 0 && !el.classList.contains('laf-verified-badge')) return;
      var t = normalizeText(el.textContent).replace(/^[✓✔☑\s]+/, '');
      if (!/^(achat vérifié|acheteur vérifié|verified|verified buyer|verified purchase)$/i.test(t)) return;
      el.classList.add('laf-global-verified-badge');
      el.textContent = 'Achat vérifié';
    });
    return clone;
  }

  function renderGlobalReviewViewer() {
    var viewer = ensureGlobalReviewViewer();
    var state = lafGlobalViewerState;
    if (!state.images.length) return;
    state.index = (state.index + state.images.length) % state.images.length;
    var current = state.images[state.index];
    var image = viewer.querySelector('.laf-global-review-viewer__image');
    image.src = globalReviewPhotoSource(current);
    image.alt = current.alt || 'Photo client agrandie';
    var details = viewer.querySelector('.laf-global-review-viewer__details');
    details.innerHTML = '';
    var clone = cleanViewerCardClone(state.card || cardForGlobalPhoto(current));
    if (clone) details.appendChild(clone);
    var multiple = state.images.length > 1;
    viewer.querySelector('[data-laf-global-prev]').hidden = !multiple;
    viewer.querySelector('[data-laf-global-next]').hidden = !multiple;
  }

  function openGlobalReviewViewer(img) {
    var viewer = ensureGlobalReviewViewer();
    var card = cardForGlobalPhoto(img);
    var images = globalPhotoGroup(img, card);
    lafGlobalViewerState = { images: images, index: Math.max(0, images.indexOf(img)), card: card, trigger: img };
    renderGlobalReviewViewer();
    viewer.classList.add('is-open');
    viewer.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('laf-global-review-viewer-open');
    document.body.classList.add('laf-global-review-viewer-open');
    var close = viewer.querySelector('.laf-global-review-viewer__close');
    if (close) window.setTimeout(function(){ close.focus({preventScroll:true}); },0);
  }

  function closeGlobalReviewViewer() {
    var viewer = document.querySelector('.laf-global-review-viewer.is-open');
    if (!viewer) return;
    viewer.classList.remove('is-open');
    viewer.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('laf-global-review-viewer-open');
    document.body.classList.remove('laf-global-review-viewer-open');
    var trigger = lafGlobalViewerState.trigger;
    lafGlobalViewerState = { images: [], index: 0, card: null, trigger: null };
    if (trigger && document.contains(trigger)) try { trigger.focus({preventScroll:true}); } catch (e) {}
  }

  function stepGlobalReviewViewer(delta) {
    if (!lafGlobalViewerState.images.length) return;
    lafGlobalViewerState.index += delta;
    renderGlobalReviewViewer();
  }

  function tryNativePhotoAncestors(img) {
    var candidates = [];
    var node = img.parentElement;
    for (var i=0; i<4 && node; i++, node=node.parentElement) {
      if (node.matches && node.matches('a,button,[role="button"],[class*="photo" i],[class*="image" i],[class*="resource" i]')) candidates.push(node);
    }
    var idx = 0;
    function attempt() {
      if (visibleTrustooPhotoViewer()) return;
      if (idx >= candidates.length) { openGlobalReviewViewer(img); return; }
      var target = candidates[idx++];
      lafGlobalPhotoBridgeGuard = true;
      try { target.click(); } catch (e) {}
      lafGlobalPhotoBridgeGuard = false;
      window.setTimeout(attempt, 90);
    }
    attempt();
  }

  function initGlobalPhotoBridge() {
    if (lafGlobalPhotoBridgeReady || !isGlobalReviewsPage()) return;
    lafGlobalPhotoBridgeReady = true;
    document.addEventListener('click', function (event) {
      if (lafGlobalPhotoBridgeGuard) return;
      var close = event.target.closest && event.target.closest('[data-laf-global-close]');
      if (close) { event.preventDefault(); closeGlobalReviewViewer(); return; }
      var prev = event.target.closest && event.target.closest('[data-laf-global-prev]');
      if (prev) { event.preventDefault(); stepGlobalReviewViewer(-1); return; }
      var next = event.target.closest && event.target.closest('[data-laf-global-next]');
      if (next) { event.preventDefault(); stepGlobalReviewViewer(1); return; }
      var img = event.target && event.target.tagName === 'IMG' ? event.target : null;
      if (!isGlobalCustomerPhoto(img)) return;
      img.classList.add('laf-global-review-photo-clickable');
      /* Let Trustoo handle the original event first. */
      window.setTimeout(function () {
        if (!visibleTrustooPhotoViewer()) tryNativePhotoAncestors(img);
      }, 140);
    }, false);
    document.addEventListener('keydown', function (event) {
      var viewer = document.querySelector('.laf-global-review-viewer.is-open');
      if (!viewer) return;
      if (event.key === 'Escape') { event.preventDefault(); closeGlobalReviewViewer(); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); stepGlobalReviewViewer(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); stepGlobalReviewViewer(1); }
    });
  }

  /* V7.11.17 — premium Trustoo write-review form.
     Trustoo can render the form outside #vstar-reviews (portal/modal), so we
     decorate it only after the native write-review control is used. All native
     inputs, validation and submission logic remain untouched. */
  var lafReviewFormArmUntil = 0;
  var lafReviewFormObserverReady = false;

  function formText(el) {
    return normalizeText(el && el.textContent).toLowerCase();
  }

  function hasLikelyReviewFormSignals(el) {
    if (!el || !el.querySelector) return false;
    var textarea = el.querySelector('textarea');
    if (!textarea) return false;
    var txt = formText(el);
    var hasReviewWords = /(write\s+(a\s+)?review|submit\s+review|review|avis|commentaire|votre\s+note|your\s+rating|you\s+rating|rating)/i.test(txt);
    var hasIdentity = !!el.querySelector('input[type="email"],input[name*="email" i],input[placeholder*="email" i]');
    var hasPhoto = !!el.querySelector('input[type="file"]');
    var hasSubmit = !!el.querySelector('button[type="submit"],input[type="submit"],button');
    return hasReviewWords && hasSubmit && (hasIdentity || hasPhoto || txt.length > 40);
  }

  function closestVisualField(el, stop) {
    if (!el) return null;
    var node = el.parentElement;
    var best = node;
    for (var i = 0; i < 4 && node && node !== stop; i++, node = node.parentElement) {
      if (!node.querySelector) break;
      var controls = node.querySelectorAll('input,textarea,select,button').length;
      if (controls <= 4) best = node;
      else break;
    }
    return best;
  }

  function markReviewFormTitle(shell) {
    var candidates = Array.prototype.slice.call(shell.querySelectorAll('h1,h2,h3,h4,h5,strong,p,div,span'));
    var title = candidates.find(function (el) {
      if (el.children.length > 2) return false;
      var t = normalizeText(el.textContent);
      return /^(écrire\s+(un\s+)?(avis|commentaire)|laisser\s+(un\s+)?avis|write\s+(a\s+)?review|write\s+(a\s+)?comment)$/i.test(t);
    });
    if (title) title.classList.add('laf-review-form-title');
  }

  function markReviewFormRating(shell) {
    var leaves = Array.prototype.slice.call(shell.querySelectorAll('label,legend,p,span,div,strong'));
    var label = leaves.find(function (el) {
      if (el.children.length > 1) return false;
      var t = normalizeText(el.textContent);
      return /^(votre\s+note|note|notation|your\s+rating|you\s+rating|rating)$/i.test(t);
    });
    if (!label) return;
    var node = label.parentElement;
    var best = node;
    for (var i = 0; i < 4 && node && node !== shell; i++, node = node.parentElement) {
      var stars = node.querySelectorAll('svg,[class*="star" i],input[type="radio"],button').length;
      if (stars >= 3 && stars <= 12) { best = node; break; }
    }
    if (best) best.classList.add('laf-review-form-rating');
  }

  function markReviewFormUpload(shell) {
    var file = shell.querySelector('input[type="file"]');
    if (file) {
      var host = closestVisualField(file, shell) || file.parentElement;
      if (host) host.classList.add('laf-review-form-upload');
    }

    Array.prototype.slice.call(shell.querySelectorAll('button,label,a,span,div')).forEach(function (el) {
      if (el.children.length > 2) return;
      var t = normalizeText(el.textContent);
      if (!/(ajouter\s+(une\s+)?photo|ajouter\s+photo|add\s+photo|photo\s*\d*\s*\/\s*\d*)/i.test(t)) return;
      var host = closestVisualField(el, shell) || el.parentElement;
      if (host) host.classList.add('laf-review-form-upload');
    });
  }

  function markReviewFormLegal(shell) {
    Array.prototype.slice.call(shell.querySelectorAll('p,small,div,span,label')).forEach(function (el) {
      if (el.children.length > 4) return;
      var t = normalizeText(el.textContent);
      if (/(privacy\s+policy|politique\s+de\s+confidentialité|personal\s+data|données\s+personnelles|terms\s+regarding)/i.test(t) && t.length < 700) {
        el.classList.add('laf-review-form-legal');
      }
      if (/(is\s+it\s+public\??|public\s*\??|visible\s+publiquement|rendre\s+cet\s+avis\s+public)/i.test(t) && t.length < 220) {
        var host = closestVisualField(el, shell) || el.parentElement;
        if (host) host.classList.add('laf-review-form-public');
      }
    });
  }

  function markReviewFormFields(form) {
    Array.prototype.slice.call(form.querySelectorAll('input,textarea,select')).forEach(function (input) {
      var type = (input.getAttribute('type') || '').toLowerCase();
      if (type === 'hidden' || type === 'file' || type === 'radio' || type === 'checkbox') return;
      var host = closestVisualField(input, form) || input.parentElement;
      if (host) host.classList.add('laf-review-form-field');
      if (input.tagName === 'TEXTAREA' && host) host.classList.add('laf-review-form-field--review');
    });
  }

  function markReviewFormSubmit(form) {
    var controls = Array.prototype.slice.call(form.querySelectorAll('button,input[type="submit"],a'));
    var submit = controls.find(function (el) {
      var t = normalizeText(el.textContent || el.value);
      return /(submit\s+review|send\s+review|publier\s+(mon\s+)?avis|envoyer\s+(mon\s+)?avis|soumettre\s+(mon\s+)?avis|valider\s+(mon\s+)?avis)/i.test(t);
    }) || form.querySelector('button[type="submit"],input[type="submit"]');
    if (submit) submit.classList.add('laf-review-form-submit');
  }

  function markReviewFormClose(shell) {
    var buttons = Array.prototype.slice.call(shell.querySelectorAll('button,[role="button"]'));
    buttons.forEach(function (el) {
      var txt = normalizeText(el.textContent);
      var aria = normalizeText(el.getAttribute('aria-label'));
      if (/^(×|x|close|fermer)$/i.test(txt) || /(close|fermer)/i.test(aria)) el.classList.add('laf-review-form-close');
    });
  }

  function reviewFormShell(form) {
    var node = form;
    var best = null;
    for (var i = 0; i < 8 && node && node !== document.body; i++, node = node.parentElement) {
      var cls = typeof node.className === 'string' ? node.className : '';
      if (node.matches && (node.matches('dialog,[role="dialog"]') || /(modal|popup|dialog|drawer)/i.test(cls))) {
        best = node;
        break;
      }
    }
    return best || form.parentElement || form;
  }

  function markReviewFormOverlay(shell) {
    if (!shell || shell === document.body) return;
    try {
      var style = window.getComputedStyle(shell);
      var rect = shell.getBoundingClientRect();
      var broad = rect.width >= window.innerWidth * .72 && rect.height >= window.innerHeight * .72;
      if (style.position === 'fixed' && broad) shell.classList.add('laf-review-form-overlay');
      else if (shell.parentElement) {
        var parent = shell.parentElement;
        var ps = window.getComputedStyle(parent);
        var pr = parent.getBoundingClientRect();
        if (ps.position === 'fixed' && pr.width >= window.innerWidth * .72 && pr.height >= window.innerHeight * .72) {
          parent.classList.add('laf-review-form-overlay');
        }
      }
    } catch (e) {}
  }

  function decorateReviewForm(form) {
    if (!form || !hasLikelyReviewFormSignals(form)) return false;
    var shell = reviewFormShell(form);
    form.classList.add('laf-review-form-card');
    if (shell) {
      shell.classList.add('laf-review-form-shell');
      shell.setAttribute('data-laf-review-form-shell', 'true');
      markReviewFormOverlay(shell);
      markReviewFormTitle(shell);
      markReviewFormRating(shell);
      markReviewFormUpload(shell);
      markReviewFormLegal(shell);
      markReviewFormClose(shell);
    }
    markReviewFormFields(form);
    markReviewFormSubmit(form);
    return true;
  }

  function decorateVisibleReviewForms() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('form'));
    var decorated = false;
    forms.forEach(function (form) {
      if (decorateReviewForm(form)) decorated = true;
    });

    /* Some Trustoo versions do not use a semantic <form>. Support those without
       ever hijacking ordinary Shopify inputs: only scan while the review action
       is armed and only containers with a textarea + review-specific copy. */
    if (!decorated && Date.now() < lafReviewFormArmUntil) {
      Array.prototype.slice.call(document.querySelectorAll('dialog,[role="dialog"],[class*="modal" i],[class*="popup" i]')).forEach(function (shell) {
        if (!shell.querySelector('textarea')) return;
        if (!/(review|avis|commentaire|rating|note)/i.test(formText(shell))) return;
        shell.classList.add('laf-review-form-shell');
        shell.setAttribute('data-laf-review-form-shell', 'true');
        markReviewFormOverlay(shell);
        markReviewFormTitle(shell);
        markReviewFormRating(shell);
        markReviewFormUpload(shell);
        markReviewFormLegal(shell);
        markReviewFormClose(shell);
        var pseudo = shell.querySelector('textarea').closest('div,section,article') || shell;
        pseudo.classList.add('laf-review-form-card');
      });
    }
    return decorated;
  }

  function armReviewFormDecoration() {
    lafReviewFormArmUntil = Date.now() + 5000;
    var delays = [0, 80, 180, 350, 700, 1200, 2000, 3200];
    delays.forEach(function (delay) {
      window.setTimeout(decorateVisibleReviewForms, delay);
    });
  }

  function initReviewFormWatcher(root) {
    if (!root) return;
    var write = findWriteControl(root);
    if (write && write.dataset.lafFormWatcher !== '1') {
      write.dataset.lafFormWatcher = '1';
      write.addEventListener('click', armReviewFormDecoration);
    }
  }

  function initGlobalReviewFormObserver() {
    if (lafReviewFormObserverReady || !window.MutationObserver || !document.body) return;
    lafReviewFormObserverReady = true;
    var queued = false;
    new MutationObserver(function () {
      if (Date.now() >= lafReviewFormArmUntil && !document.querySelector('.laf-review-form-card')) return;
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        decorateVisibleReviewForms();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function decorateTrustoo() {
    initScroll();
    var root = getRoot();
    if (!root) return false;
    initReviewFormWatcher(root);
    if (!isGlobalReviewsPage()) markNativeReviewSwitch(root);

    cleanTrustooTitle(root);
    formatFrenchScores(root);
    markSummaryScore(root);
    var breakdown = markBreakdown(root);
    var gallery = markGallery(root);
    arrangeOverview(root, breakdown, gallery);
    markReviewBody(root);
    /* The LAF heading now exists, so place/protect Trustoo's native switch and
       always expose the two LAF review-type tabs underneath it. */
    if (!isGlobalReviewsPage()) markNativeReviewSwitch(root);
    ensureVisibleReviewTabs(root);
    var body = root.querySelector('#reviews-body');
    var overview = root.querySelector('.laf-trustoo-overview');
    restoreTrustooFooter(root);
    if (body) {
      decorateAllReviewVariants(body);
      var stableCount = decorateStableReviewUnits(body);
      /* Fallback only when Trustoo does not expose usable review dates. */
      if (!stableCount) {
        var heuristicCount = decorateHeuristicReviewCards(body);
        if (!heuristicCount) buildPremiumReviewList(body);
      }
    }
    if (overview && body) {
      hideNativeSummaryShells(root, overview, body);
      hideOrphanSummaryBlocks(root, overview, body);
    }
    root.setAttribute('data-laf-trustoo-ready', 'true');
    return true;
  }

  function init() {
    initScroll();
    initGlobalPhotoBridge();
    initGlobalReviewFormObserver();
    var tries = 0;
    var timer = setInterval(function () {
      if (decorateTrustoo()) {
        clearInterval(timer);
        var root = getRoot();
        if (root && window.MutationObserver) {
          var queued = false;
          new MutationObserver(function () {
            if (queued) return;
            queued = true;
            window.requestAnimationFrame(function () {
              queued = false;
              decorateTrustoo();
            });
          }).observe(root, { childList: true, subtree: true, characterData: true });
        }
      } else if (++tries > 40) {
        clearInterval(timer);
      }
    }, 300);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
